import { render, staticRenderFns } from "./ModalAnexo.vue?vue&type=template&id=5d268d9e&scoped=true&lang=pug&"
import script from "./ModalAnexo.vue?vue&type=script&lang=js&"
export * from "./ModalAnexo.vue?vue&type=script&lang=js&"
import style0 from "./ModalAnexo.vue?vue&type=style&index=0&id=5d268d9e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d268d9e",
  null
  
)

export default component.exports